import { State } from 'redux/utils/Details'
export default State()
